export const WIDE_BREAKPOINT_1 = 1200;

export const NARROW_BREAKPOINT_0 = 1092;
export const NARROW_BREAKPOINT_1 = 972;
export const NARROW_BREAKPOINT_2 = 768;
export const NARROW_BREAKPOINT_3 = 500;
export const NARROW_BREAKPOINT_4 = 300; // -- minimum supported screen width
